// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  GetRefundDetails, GetWithdrawalDetails } from '@api';


export const getRefundDetailsApi = createAsyncThunk('refund/get_refund_details', async args => { 
  const response = await GetRefundDetails(args); 
  return response.data;
}) 

export const getWithdrawalDetailsApi = createAsyncThunk('refund/get_withdrawal_details', async args => { 
  const response = await GetWithdrawalDetails(args); 
  return response.data;
}) 

export const getRefundDetailsSlice = createSlice({
  name: 'refunddetailsmodel',
  initialState: {  
    withdrawalReason:"",
    documentStatus:""
  },
  reducers: {  },
  extraReducers: builder => {
    builder      
    .addCase(getRefundDetailsApi.fulfilled, (state, action) => { })    
    .addCase(getWithdrawalDetailsApi.fulfilled, (state, action) => {
      state.withdrawalReason = action.payload.reason;
      state.documentStatus = action.payload.documentStatus;
    })
  }
})

export default getRefundDetailsSlice.reducer

